<template>
  <div class="pirate">
    <div class="sections">
      <SectionTitle :name="name" :amount="amount" @apply="apply"/>
    </div>
    <div class="button">
      <button class="btn-kakao slow" v-inview:animate="'fadeIn'" @click="apply">
        1분 안에 상담받기 <img src="@/assets/images/main/arrow.svg">
      </button>
    </div>
  </div>
</template>

<script>

// API Section
import applicationApi from '@/api/now/applicationApi'

// Components Section
import SectionTitle from './components/SectionTitle'

// Variable Section
let self

export default {
  name: 'pirate',
  components: {
    SectionTitle
  },
  data: function () {
    return {
      name: null,
      phone: null,
      amount: null,
    }
  },
  async created() {
    self = this
    if (self.$route && self.$route.query) {
      self.name = self.$route.query.name
      self.amount = self.$route.query.amount
    }
  },
  methods: {
    async apply() {
      if (self.$route.query.phone) {
        await applicationApi.postApplication(self.$route.query)
        alert('정상적으로 접수되었습니다. 상담원이 ' + self.$route.query.phone + ' 번호로 연락드릴 예정입니다. 잠시만 기다려주세요!')
      } else {
        let name = prompt('이름을 입력해주세요.')
        let phone = prompt('전화번호를 입력해주세요.')
        await applicationApi.postApplication({ name: name, phone: phone })
        alert('정상적으로 접수되었습니다. 상담원이 ' + phone + ' 번호로 연락드릴 예정입니다. 잠시만 기다려주세요!')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .pirate {
    background-color: white;
    min-height: 100vh;

    .sections {
      position: relative;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 2;
      float: left;
    }

    .button {
      position: fixed;
      left: 0px;
      bottom: 30px;
      width: 100%;
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: center;

      button.btn-kakao {
        width: calc(335% / 375 * 100);
        max-width: 600px;
        height: 64px;
        font-size: 20px;
        color: white;
        font-weight: 900;
        background-color: #333333;
        border-radius: 32px;
        box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.14);

        /*animation-name: pulse;*/
        /*animation-duration: 3s;*/
        /*animation-timing-function: ease;*/
        /*animation-delay: 3s;*/
        /*animation-iteration-count: infinite;*/
        &:hover {
          color: white !important;
          background-color: #333333 !important;
        }
        img {
          width: 17px;
          margin-left: 5px;
        }
      }
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(0.98);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
      transform: scale(0.98);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
</style>
